
import { ViewElement, ViewTemplate, Element, LevelElement } from './types';

export class ViewManager {
    private views: Map<string, ViewElement> = new Map();
    private templates: Map<string, ViewTemplate> = new Map();

    /**
     * Create default Views and Templates
     */
    constructor() {
        // Default Template
        this.createViewTemplate('Architectural Plan', {
            top: 2.3, cut: 1.2, bottom: 0, depth: 0
        }, 100);
    }

    createViewTemplate(name: string, range: any, scale: number): ViewTemplate {
        const t: ViewTemplate = {
            id: `vt-${name.replace(/\s/g, '')}`,
            name,
            includeScale: true,
            scale,
            includeViewRange: true,
            viewRange: {
                top: range.top,
                cut: range.cut,
                bottom: range.bottom,
                depth: range.depth
            },
            includeModelDisplay: false,
            modelDisplay: 'Normal'
        };
        this.templates.set(t.id, t);
        return t;
    }

    /**
     * Check if an element is visible in the view range.
     * Simplified 2D check for Plan Views.
     */
    isVisibleInView(view: ViewElement, element: Element, level: LevelElement): boolean {
        // 1. Level Check
        // If view is associated with Level 1, we show elements on Level 1 (and below/above based on range)

        // Element Z position
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _zMin = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _zMax = 0;

        // Heuristic to get Z bounds
        if ((element as any).geometryData) {
            const geom = (element as any).geometryData;
            if (geom.location) { // Column
                // _zMin = geom.bottomOffset; // relative to base level?
                // Need to resolve global Z.
                // For this mock, assume element has a 'levelId' or 'elevation'
                // Or we pass absolute Z values.

                // Let's assume we are checking "is it within Cut Plane?"
            }
        }

        const cutOffset = view.viewRange?.cut || 1.2;
        const levelElev = level.geometryData?.elevation || 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _cutPlaneZ = levelElev + cutOffset;

        // To be implemented fully: Bounding Box intersection with Cut Plane
        return true;
    }

    /**
     * Get effective View Range (Template override)
     */
    getEffectiveViewRange(view: ViewElement): any {
        if (view.viewTemplateId) {
            const t = this.templates.get(view.viewTemplateId);
            if (t && t.includeViewRange) {
                return t.viewRange;
            }
        }
        return view.viewRange;
    }

    /**
     * Set scale
     */
    setScale(view: ViewElement, scale: number) {
        if (view.viewTemplateId) {
            const t = this.templates.get(view.viewTemplateId);
            if (t && t.includeScale) {
                // Cannot change, controlled by template
                console.warn("Cannot change scale; controlled by View Template");
                return;
            }
        }
        view.scale = scale;
    }
}
